import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { marked } from 'marked';

@Component({
    selector: 'app-ai-analysis-result',
    templateUrl: './ai-analysis-result.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AiAnalysisResultComponent implements OnInit, OnDestroy {
    @Input() public result$: Observable<string>;

    public result: string = '';
    public resultMd: string = '';

    private buffer: string = '';
    private flushTimer: NodeJS.Timeout | null = null;

    private unsubscribeAll = new Subject<void>();

    public ngOnInit(): void {
        this.result$.pipe(takeUntil(this.unsubscribeAll)).subscribe(r => {
            this.buffer += r;
            this.startFlushTimer();
        });
    }

    public ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    private startFlushTimer(): void {
        if (this.flushTimer) return;

        const intervalMs = 10;

        this.flushTimer = setInterval(() => {
            this.flushTimer = null;
            this.flush();
        }, intervalMs);
    }

    private flush(): void {
        if (!this.buffer.length) {
            if (this.flushTimer) {
                clearInterval(this.flushTimer);
                this.flushTimer = null;
            }
            return;
        }

        const chunkSize = 3;

        const chunk = this.buffer.slice(0, chunkSize);
        this.buffer = this.buffer.slice(chunkSize);

        this.result += chunk;
        this.resultMd = marked.parse(this.result) as string;
    }
}
